import { registerGa4Events } from '../../tracking/dataLayerAdapter';

declare module '@platform/tracking' {
  interface TrackingEvents {
    error_toast_shown: { error_type: string; status_code?: number };
  }
}

registerGa4Events({
  error_toast_shown: (p) => ({
    event: 'error',
    event_description: 'error_toast_shown',
    event_details: `${p.error_type}${p.status_code ? `_${p.status_code}` : ''}`,
  }),
});
